import { ServiceHookFactory } from "andculturecode-javascript-react";
import { ProviderFeeInvoiceRecord } from "models/view-models/providers/provider-fee-invoice-record";

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint: string = "providerfeeinvoices";
const resourceType: typeof ProviderFeeInvoiceRecord = ProviderFeeInvoiceRecord;
const resourceEndpoint = `${baseEndpoint}/:id`;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region enum
// -------------------------------------------------------------------------------------------------

// #endregion enum

export interface ProviderFeeInvoiceResourcePathParams
{
    id: number;
    providerId: number;
}
export interface ListProviderFeeInvoicesQueryParams
{
    providerId?: number;
    year?: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const ProviderFeeInvoiceService = {
    useCreate: ServiceHookFactory.useCreate<ProviderFeeInvoiceRecord>(resourceType, baseEndpoint),

    /**
     * Custom hook for leveraging service get calls in React components
     */
    useGet: ServiceHookFactory.useGet<ProviderFeeInvoiceRecord, ProviderFeeInvoiceResourcePathParams>(
        resourceType,
        resourceEndpoint
    ),

    useGetProviderFeeInvoice: ServiceHookFactory.useNestedList<
        ProviderFeeInvoiceRecord,
        ProviderFeeInvoiceResourcePathParams,
        undefined
    >(ProviderFeeInvoiceRecord, resourceEndpoint),

    /**
     * Custom hook for leveraging service update calls in React components
     */
    useUpdate: ServiceHookFactory.useUpdate<ProviderFeeInvoiceRecord, ProviderFeeInvoiceResourcePathParams>(
        resourceType,
        resourceEndpoint
    ),

    /**
     * Custom hook for leveraging service index calls in React components
     */
    useList: ServiceHookFactory.useList<ProviderFeeInvoiceRecord, ListProviderFeeInvoicesQueryParams>(
        resourceType,
        baseEndpoint
    ),

};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderFeeInvoiceService };

// #endregion Exports
